const shouldDisplayDesktopAnimatedBannerAd = window.innerWidth > 1280;
const shouldDislayDesktopTowerAd = window.innerWidth > 1798;
const shouldDisplayMobileFooterAd = !shouldDislayDesktopTowerAd

export { shouldDisplayDesktopAnimatedBannerAd, shouldDislayDesktopTowerAd, shouldDisplayMobileFooterAd };
